import { Declaration } from 'store/declarations/declaration';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';
import { IrelandImportDeclaration } from 'store/declarations/ireland/import-declaration';
import InvoiceFormHeader from './InvoiceFormHeader';
import InvoiceModal from './InvoiceModal';

const InvoiceModalButton = ({
    declaration,
    saveAsDraft,
    formikValues,
}: {
    declaration: Declaration | undefined;
    saveAsDraft?: Function;
    formikValues: IrelandImportDeclaration;
}) => {
    const isDraft = declaration?.status === DeclarationStatuses.DRAFT;
    const declarationHasInvoice = declaration?.uploadedFiles?.some((uploadedFile) => uploadedFile.invoice);
    const shouldDisplayModal = isDraft && declarationHasInvoice;

    return (
        <>
            {declarationHasInvoice && <InvoiceFormHeader disabled={!shouldDisplayModal} />}
            {shouldDisplayModal && (
                <InvoiceModal formikValues={formikValues} declarationId={declaration?.id} saveAsDraft={saveAsDraft} />
            )}
        </>
    );
};

export default InvoiceModalButton;
